module.exports = __webpack_public_path__ + "img/ifmBi.e396ed6a.svg";